import { flex } from './flex';
import { background } from './background';
import { fit } from './object-fit';
import { rem } from './rem';
import {
  sm, md, lg, xl, custom,
} from './media-query';

export default {
  flex,
  bg: background,
  fit,
  rem,
  sm,
  md,
  lg,
  xl,
  custom,
};
